// extracted by mini-css-extract-plugin
module.exports = {"sort-by":"StoreList_sort-by__Ed_Gn"};